import { LAUNCHITEMSMODEL } from "model/launchItemsMode";
// import UPCOMING1 from "assets/upcoming/upcoming1.webp";
export const UPCOMINGITEMS: LAUNCHITEMSMODEL[] = [
  // {
  //   id: 9,
  //   image: UPCOMING1,
  // },
];
